import React from "react";
import { Link } from "react-router-dom";
import { ExtendedComponents } from "@/components/extended";
import { ROUTES } from "@/shared/constants";
import { HeaderTrialIndicatorProps } from "@/shared/type/Header.type";

const HeaderTrialIndicator = ({
  badgeLabel,
  formattedExpiry,
}: HeaderTrialIndicatorProps): React.ReactElement => {
  return (
    <ExtendedComponents.customTooltip
      className="max-w-80"
      triggerChild={
        <button
          type="button"
          aria-label={badgeLabel}
          className="flex items-center rounded-20 border border-border bg-white px-3.5 py-2 text-xs font-medium text-foreground"
          style={{ backgroundColor: "var(--warning)" }}
        >
          <span>{badgeLabel}</span>
        </button>
      }
      triggerContent={
        <p className="text-sm leading-5">
          Your trial will end on {formattedExpiry} UTC, please contact support
          if you need any assistance.{" "}
          <Link
            to={ROUTES.header.contactSupport}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold underline"
          >
            Contact Support
          </Link>
        </p>
      }
    />
  );
};

export default HeaderTrialIndicator;
